import React, { useState,useContext,useEffect } from 'react'
import MainMenu from '../../Pages/RE/ReMainMenu'
import Card from '../../Components/RE/ReListCard/AdvisorListCard'
import FilterTag from '../../Components/Tag'
import Table from '../../Components/RETransactionAdvisor/AllTableComponent'
import RefineSearch from '../../Components/RefineSearchComponent'
import ReLayout from '../../Components/ReLayout'
import MonthPickerComponent from "../../Utils/MonthPickerComponent";
import xls from "../../images/xls/png/Group 47.png";
import FileIcon from "../../images/file.png";
import FileIconBlur from "../../images/fileblur.png";
import line from "../../images/line.png";
import SavedFilterContent from "../../Components/SavedFilter";
import SavedFilterICON from "../../Components/SavedFilter/SavedFilterICON";
import ExportPopup from "../../Components/ExportPopup";
import { reAdvisorListExport } from "../../Config/config";
import Constants from '../../Constants'
import { useLocation } from 'react-router-dom'
import { reTransactionAdvisorOtherMAExportData } from "../../Components/ExportPopup/ExportData"
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import ReInvestorExitRefineSearch from '../../Components/RefineSearch/ReInvestorExitRefineSearch'
import { UserContext } from '../../Contexts/UserContext'
import { TableDataContext } from '../../Contexts/TableDataContext'
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { Tooltip } from 'antd'
import { RiMailDownloadLine } from 'react-icons/ri'
import DownloadTrigger from '../../Components/ExportPopup/DownloadTrigger'

/**
 * The REAngelInvestment function is a JavaScript function that renders a component for displaying RE
 * Advisor Other MA transactions and provides filtering and search functionality.
 * @returns a JSX element.
 */
function REAngelInvestment() {

    const {save, setSave,showMonthPicker,refineSearchFilters ,groupId, isMobile,setOpen,open,setIsMobile} = useContext(PeFilterContext);
    const [showPopup, setShowPopup] = useState(false);
    const savedList = () => {
        setSave(!save)
    }
    const {isTrialExport,isStudent} = useContext(UserContext)
    const {globalSearchResult} = useContext(TableDataContext);

    const location = useLocation();
    const {pathname} = useLocation()
    /**
     * The function checks if there are any global search filters applied 
     */
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const pathKey = location.pathname.split("/").slice(0, 3).join("/");
    document.title = "RE Transaction Advisors PE-RE Other M&A - Venture Intelligence"
    useEffect(()=>{
        if (window.innerWidth < 800) {
            // setOpen(true);
            setIsMobile(true);
        }    },[])
    return (
        <ReLayout>
            <div className="flex min-h-screen h-screen flex-col">
                <div className="flex min-h-0 flex-1 overflow-hidden">
                    <main className={`min-w-0 mt-14 flex-1 md:border-t border-gray-200 flex `}>
                        <section className="flex h-full min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED]">
                            <div></div>
                            <div className="pl-3 pr-4 lg:pr-4 md:pr-[0.7rem]">
                                <div className="scrollbar ">
                                    <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between  ">

                                        <div></div>
                                        
                                        <div className={"justify-between items-center px-2 py-2 space-x-4 "+(showMonthPicker!=0 ? 'md:flex':'flex')}>
                                                <div></div>
                                                <div className={showMonthPicker!=0 ?"hidden md:flex space-x-3":"flex space-x-3"}>   
                                                    {isTrialExport == 'false' || isStudent == 'true' ? <></> :<>
                                                        <button>
                                                        <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                                            {showPopup && (
                                                                <ExportPopup 
                                                                modules="advisor"
                                                                module="transaction-advisor"
                                                                fileName={Constants.exportNames.re_advisor_ipos}
                                                                url={reAdvisorListExport}
                                                                onClose={() => setShowPopup(false)} 
                                                                advisor_type="T"
                                                                exportOptions={reTransactionAdvisorOtherMAExportData} 
                                                                type="other-manda"  />
                                                            )}
                                                        </button>                                                
                                                    
                                                    </>}
                                                </div>
                                            </div>
                                        
                                    </div>
                                </div>
                                
                            </div>
                            <div className='overflow-y-auto'>
                                <Table menu="re-advisor-otherma" advisor_type="T" sub_type_master_id={Constants.subCategoryIds.re_tadvisor_otherma_id} />
                            </div>
                            {/* <Outlet /> */}
                            {/* Your content */}
                        </section>

                    </main>
                </div>
            </div>
        </ReLayout>
    )
}

export default REAngelInvestment
